<template>
  <div>
    <figure v-if="blog.cover" class="image is-5by3">
      <img :style="`background: no-repeat url(${blog.cover.url}) 100%/cover`" />
    </figure>

    <div class="columns is-vcentered tw-mb-0">
      <div class="column">
        <div class="section-block no-border">
          <span class="title is-size-2 tw-text-uppercase">
            {{ blog.title }}
          </span>
        </div>
      </div>
      <div class="column is-narrow share">
        <social-sharing
          :url="blogUrl"
          :title="blog.title"
          :description="blog.subtitle"
          :quote="blog.subtitle"
          inline-template
        >
          <div>
            <network class="social twitter tw-mr-3" network="twitter">
              <i class="mdi mdi-twitter tw-text-twitter tw-self-center" />
            </network>
            <network class="social facebook" network="facebook">
              <i class="mdi mdi-facebook tw-text-facebook tw-self-center" />
            </network>
          </div>
        </social-sharing>
      </div>
    </div>

    <p class="subtitle is-size-5 tw-leading-normal">
      {{ blog.subtitle }}
    </p>

    <div class="content quill" v-html="blog.content"></div>

    <slot :blogUrl="blogUrl" name="comment"></slot>
  </div>
</template>

<script>
import Blog from '@/models/Blog'
export default {
  props: {
    blog: {
      type: Blog
    }
  },
  data() {
    return {
      blogUrl: ''
    }
  },
  mounted() {
    this.setBlogUrl()
  },
  methods: {
    setBlogUrl() {
      this.blogUrl = window.location.href
    }
  },
  watch: {
    blog() {
      this.setBlogUrl()
    }
  }
}
</script>
